<template>
  <b-container>
    <b-row>
      <b-col>
        <ParcoursSelector :current_parcours="current_parcours" :list_parcours="list_parcours" @changeParcours="changeParcours"></ParcoursSelector>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12" class="content_container" style="padding: 15px 15px !important">
        <b-row>
          <b-col md="6">
            <h3 class="align_left" v-if="lines.length > 0 && parcours.trace">
              <b-icon icon="dash" class="primary_color" aria-hidden="true"></b-icon>
              {{ $t("tab_parcours.profil_parcours") }}
            </h3>
          </b-col>
          <b-col md="6">
            <SelectFondMap></SelectFondMap>
          </b-col>
        </b-row>

        <ParcoursMap v-if="lines.length > 0 && parcours.trace" :lines="lines" :parcours="parcours" :focus_point="focus_point" :key="parcours.id"></ParcoursMap>

        <ParcoursProfil v-if="lines.length > 0 && parcours.trace" :lines="lines" :parcours="parcours" :key="parcours.nom" v-on:focus_point="setFocusPoint"></ParcoursProfil>
        <br />

        <div v-if="parcours && parcours.trace && $store.state.admin.allow_gpx_download == '1' && parcours.trace.length > 0">
          <a :href="'https://sportips.fr/live/' + parcours.trace" download
            ><b-button class="download_gpx_btn with_icon"><b-icon icon="download" aria-hidden="true"></b-icon>Télécharger la trace GPX</b-button></a
          >
        </div>
        <hr />
        <ParcoursRecapBlocs v-if="current_recap_blocs.length > 0" :content="current_recap_blocs"></ParcoursRecapBlocs>
        <h3 class="align_left" style="margin-top: 30px" v-if="current_extra_informations.length > 0">
          <b-icon icon="dash" class="primary_color" aria-hidden="true"></b-icon>
          {{ $t("tab_parcours.infos_complementaires") }}
        </h3>
        <ParcoursExtraInformations v-if="current_extra_informations.length > 0" :content="current_extra_informations"></ParcoursExtraInformations>

        <transition name="fade">
          <div v-if="(lines.length <= 0 || !parcours.trace) && !$store.state.loading">
            <h3>{{ $t("tab_parcours.erreur_profil_parcours") }}</h3>
            <router-link to="courses"
              ><b-button class="inline-btn">{{ $t("retour") }}</b-button></router-link
            >
          </div>
        </transition>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import axios from "axios";
import toGeoJSON from "@mapbox/togeojson/togeojson.js";
import ParcoursSelector from "@/components/Parcours_tab/ParcoursSelector.vue";
import ParcoursMap from "@/components/Parcours_tab/ParcoursMap.vue";
import ParcoursProfil from "@/components/Parcours_tab/ParcoursProfil.vue";
import ParcoursExtraInformations from "@/components/Parcours_tab/ParcoursExtraInformations.vue";
import ParcoursRecapBlocs from "@/components/Parcours_tab/ParcoursRecapBlocs.vue";
import SelectFondMap from "@/components/FondMapSelector.vue";
export default {
  components: {
    ParcoursSelector,
    ParcoursMap,
    ParcoursProfil,
    ParcoursExtraInformations,
    ParcoursRecapBlocs,
    SelectFondMap,
  },
  data() {
    return {
      current_parcours: "",
      current_extra_informations: [],
      current_recap_blocs: [],
      lines: [],
      focus_point: 0,
      recomputer: 0,
    };
  },
  computed: {
    parcours() {
      this.recomputer;
      if (!this.$store.state.module.list_parcours) {
        return {};
      }
      for (var i = 0; i < this.$store.state.module.list_parcours.length; i++) {
        if (this.$store.state.module.list_parcours[i].nom === this.current_parcours) {
          return this.$store.state.module.list_parcours[i];
        }
      }
      return this.$store.state.module.list_parcours[0];
    },

    list_parcours() {
      this.recomputer;
      var list = [];
      if (this.$store.state.module.list_parcours) {
        for (var i = 0; i < this.$store.state.module.list_parcours.length; i++) {
          if (this.$store.state.module.list_parcours[i].is_live) {
            list.push(this.$store.state.module.list_parcours[i].nom);
          }
        }
      }
      return list;
    },
  },
  methods: {
    setFocusPoint(p) {
      this.focus_point = p;
    },
    changeParcours(p) {
      this.current_parcours = p;
      this.buildLines();
      this.fetchExtraInformations();
    },
    buildLines() {
      if ((this.current_parcours === "" || this.current_parcours == null) && this.$store.state.module.list_parcours) {
        this.current_parcours = this.$store.state.module.list_parcours[0].nom;
      }

      if (this.parcours) {
        var _this = this;
        if (this.parcours.trace) {
          axios.get("https://sportips.fr/live/" + this.parcours.trace).then(function (response) {
            var geojson = toGeoJSON.gpx(new DOMParser().parseFromString(response.data, "text/xml"));
            _this.lines = geojson.features[0].geometry.coordinates;
            _this.$store.commit("unsetLoading");
          });
        } else {
          _this.$store.commit("unsetLoading");
        }
      } else {
        this.$store.commit("unsetLoading");
      }
    },
    fetchExtraInformations() {
      for (var i = 0; i < this.$store.state.admin.extra_parcours_content.length; i++) {
        if (this.parcours.id === this.$store.state.admin.extra_parcours_content[i].id_parcours) {
          this.current_extra_informations = this.$store.state.admin.extra_parcours_content[i].content;
          this.current_recap_blocs = this.$store.state.admin.extra_parcours_content[i].blocs_recap;
        }
      }
    },
    async loadModuleParcours() {
      this.$store.commit("setLoading");
      var _this = this;
      let res;
      if (this.$store.state.module.nm == 1) {
        res = await axios.get(this.$store.state.base_url + "/nm/parcours/get.php?id=" + this.$store.state.module.id + "&base=" + this.$store.state.module.base);
      } else {
        res = await axios.get(this.$store.state.base_url + "/parcours/get.php?id=" + this.$store.state.module.id + "&base=" + this.$store.state.module.base);
      }

      if (res.data) {
        this.$store.commit("setParcours", res.data);

        _this.recomputer++;
        _this.buildLines();
        _this.fetchExtraInformations();
        _this.$forceUpdate();
      }
      this.$store.commit("unsetLoading");
    },
  },
  mounted() {
    if (this.$route.params.course && this.$route.params.course != "") {
      this.current_parcours = this.$route.params.course;
    }
    if (!this.$store.state.module.list_parcours) {
      this.loadModuleParcours();
    } else {
      this.buildLines();
      this.fetchExtraInformations();
    }
  },
  created() {
    this.$store.commit("setLoading");
  },
};
</script>

<style lang="sass" scoped>
</style>